import { createSlice } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    toast: {
      visible: false,
      title: "",
      message: "",
      type: "warning",
    },
  },
  reducers: {
    showToast: (state, action) => {
      state.toast = { visible: true, ...action.payload };
    },
    hideToast: (state) => {
      state.toast.visible = false;
    },
  },
});

export const { showToast, hideToast } = uiSlice.actions;
export default uiSlice.reducer;
